/**
 * RGR11 반품작업_신규 엔드포인트. (LOGISPRD-12104, moms-be `ReturnWorkController`·
 * `ReturnWorkRegistrationSaveController`·`ReturnOrderSearchController`·`CommonFileController`)
 *
 * 1.0 대조표
 *
 * | 동작                     | 1.0                                  | 2.0                                          |
 * |--------------------------|---------------------------------------|-----------------------------------------------|
 * | 반송장·원송장·합포 조회  | `POST /api/grid/search` (RGR11_HEAD) | `GET  /api/v1/return/work-invoices`           |
 * | 상품바코드 조회          | `POST /api/grid/search` (RGR11_ITEM) | `GET  /api/v1/return/work-items`              |
 * | 저장·검수완료            | `POST /api/grid/save` (MENU_CD=RGR11)| `POST /api/v1/return/work-registrations/save` |
 * | 주문검색 팝업 조회       | `POST /api/common/search`            | `GET  /api/v1/return/management/order-search` |
 * | 첨부 키 발급             | `POST /api/common/resource`          | `POST /api/v1/common/file/uploads`            |
 * | 첨부 presigned 발급      | `POST /api/common/s3`                | (위 응답에 통합 — `uploadUrl`, `signedHeaders`)|
 * | 첨부 연결                | `PATCH /api/common/resource`         | `PATCH /api/v1/common/file/uploads`           |
 *
 * 1.0 API(`/api/grid/*`, `/api/internal/data/send`, `/api/common/*`) 잔존은 0건이다.
 * D7 의 다운로드 사유코드 콤보 예외는 이 화면에 다운로드가 없어 해당하지 않는다.
 */
export const WORK_INVOICES_URL = '/api/v1/return/work-invoices'
export const WORK_ITEMS_URL = '/api/v1/return/work-items'
export const WORK_REGISTRATIONS_SAVE_URL = '/api/v1/return/work-registrations/save'
export const ORDER_SEARCH_URL = '/api/v1/return/management/order-search'
export const FILE_UPLOADS_URL = '/api/v1/common/file/uploads'
